import { apiAService, apiService } from "../apiService";
import urlConfig from "../../../config/domain";
import { jwtToken } from "../../types/genericTypes";
import LoginService,{getinvAccDet} from "../login/loginService";
import moment from "moment";

let pToken: jwtToken | null = LoginService.pToken,
  userID = pToken ? pToken.username : null;
  let invOnlyAcc = getinvAccDet();

//after redirect reinstate pToken with parsed jwt token
const pTokenCheck = (paramChk?: keyof jwtToken) => {
  if (!pToken) {
    pToken = LoginService.pToken;
    userID = pToken ? pToken.username : null;
  }
  return paramChk && pToken ? pToken[paramChk] : pToken;
};
export const AProfileGetClientDetails = (
  callback: CallableFunction,
  param: "All" | "P" | "D" | "B",
  accType: "EQ" | "CO"
) => {
  if (pTokenCheck("accType")) {
    apiService(
      {
        url: urlConfig.profile.clientDetails + accType + "/" + pToken?.accType,
        method: "GET",
        authType: "bearer",
      },
      callback
    );
  }
};

export const asyncGetClientDetails = async (
  param: "All" | "P" | "D" | "B",
  accType: "EQ" | "CO"
) => {
  if (pTokenCheck("accType")) {
    return await apiAService({
      url: urlConfig.profile.clientDetails + accType + "/" + pToken?.accType,
      method: "GET",
      authType: "bearer",
    });
  }
};

export const AProfileGetPersonalDetails = (callback: CallableFunction) => {
  if (pTokenCheck("accType")) {
    apiService(
      {
        url:
          pToken?.accType !== "CO"
            ? urlConfig.profile.personalDetails
            : urlConfig.profile.personalDetailsCOM,
        method: "GET",
        authType: "bearer",
      },
      callback
    );
  }
};

export const asyncGetPersonalDetails = async () => {
  if (pTokenCheck("accType")) {
    return await apiAService({
      url:
        pToken?.accType !== "CO"
          ? urlConfig.profile.personalDetails
          : urlConfig.profile.personalDetailsCOM,
      method: "GET",
      authType: "bearer",
    });
  }
};
export const AClientProfilePicture = (callback: CallableFunction) => {
  if (pTokenCheck("accType")) {
    //ClientProfilePicture api call
    apiService(
      {
        url: urlConfig.profile.ClientProfilePicture,
        method: "GET",
        authType: "bearer",
      },
      callback
    );
  }
};

export const asyncGetProfilePicture = async () => {
  if (pTokenCheck("accType")) {
    return await apiAService({
      url: urlConfig.profile.ClientProfilePicture,
      method: "GET",
      authType: "bearer",
    });
  }
};
export const AServicingDetails = (callback: CallableFunction) => {
  if (pTokenCheck("accType")) {
    //ServicingDetails api call
    apiService(
      {
        url:
          pToken?.accType !== "CO"
            ? urlConfig.profile.ServicingDetails
            : urlConfig.profile.ServicingDetailsCOM,
        method: "GET",
        authType: "bearer",
      },
      callback
    );
  }
};

export const asyncServicingDetails = async () => {
  if (pTokenCheck("accType")) {
    return await apiAService({
      url:
        pToken?.accType !== "CO"
          ? urlConfig.profile.ServicingDetails
          : urlConfig.profile.ServicingDetailsCOM,
      method: "GET",
      authType: "bearer",
    });
  }
};

export const asyncGetMessageDetails = async () => {
  if (pTokenCheck("accType")) {
    return await apiAService({
      url:
        pToken?.accType !== "CO"
          ? urlConfig.profile.GetMessageDetails
          : urlConfig.profile.GetMessageDetailsCOM,
      method: "GET",
      authType: "bearer",
    });
  }
};

export const asyncGetServiceRequest = async (id?: number) => {
  if (pTokenCheck("accType")) {
    var edDate = new Date();
    var stDate = new Date(moment().subtract(7, 'days').format());
    var stDt = moment(new Date(stDate)).format('YYYY-MM-DD');
    var edDt = moment(new Date(edDate)).format('YYYY-MM-DD'); 
    var tempQString = stDt + "/" + edDt + "/";  
    return await apiAService({
      url: invOnlyAcc?urlConfig.BadlvProfile.GetServiceRequest + tempQString + `${id ? id : 0}`  :urlConfig.profile.GetServiceRequest + tempQString + `${id ? id : 0}`  ,
      method: "GET",
      authType: "bearer",
    });
  }
};
